<template>
  <v-sheet color="white" class="rounded-lg shadow pa-0 ma-0">
    <output-variables-toolbar
      ref="output_toolbar"
      :expanded="expanded"
      :highlighted="highlighted"
      :show-review-help="showReviewHelp"
      class="ma-0 pa-0"
      @expandClicked="expandClicked"
      @userSelectedOutputVariables="userSelectedOutputVariables"
    />
    <v-container v-show="true" fluid fill-width class="pa-0 ma-0">
      <v-row class="pa-0 ma-0">
        <v-col cols="12">
          <v-chip
            v-if="showHelpChip && selectedAnalysisMode == 'Predictor based'"
            label
            close
            color="#4caf50"
            class="font-weight-bold white--text pa-3 my-5"
            @click:close="showHelpChip = false"
          >
            Click on
            <v-icon dark medium class="px-2 white--text" color="primary"
              >add_circle</v-icon
            >
            button and select one or more outcome variables.
          </v-chip>
          <v-chip
            v-if="showHelpChip && selectedAnalysisMode == 'Outcome based'"
            label
            close
            color="#4caf50"
            class="font-weight-bold white--text pa-3 my-5"
            @click:close="showHelpChip = false"
          >
            Click on
            <v-icon dark medium class="px-2 white--text" color="primary"
              >add_circle</v-icon
            >
            button and select one outcome variable.
          </v-chip>

          <predictor-analysis-charts
            v-if="
              hasUserAddedOutputVariables &&
                selectedAnalysisMode == 'Predictor based'
            "
            @userChangedOutputVariable="userChangedOutputVariable"
          />

          <outcome-analysis-charts
            v-else-if="
              hasUserAddedOutputVariables &&
                selectedAnalysisMode == 'Outcome based'
            "
            :show-filter-help="showFilterHelp"
            @userResetOutputVariable="userChangedOutputVariable"
            @userChangedOutputVariable="userChangedOutputVariable"
            @comparePredefinedRanges="comparePredefinedRanges"
            @savePredefinedRanges="savePredefinedRanges"
          />

          <v-subheader
            v-else
            class="subheading primary--text text--lighten-4 text-h6"
          >
            {{
              selectedAnalysisMode == 'Predictor based'
                ? 'CHOOSE OUTCOME VARIABLES'
                : 'CHOOSE AN OUTCOME VARIABLE'
            }}
          </v-subheader>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapState } from 'vuex';
import { state } from '@/store/modules/cohortManager/types';
import OutputVariablesToolbar from '@/components/CohortManager/OutputVariablesToolbar.vue';
import PredictorAnalysisCharts from '@/components/CohortManager/OutputVariablesCharts.vue';
import OutcomeAnalysisCharts from '@/components/CohortManager/OutcomesAnalysis/OutputVariableChart.vue';

export default {
  components: {
    OutputVariablesToolbar,
    PredictorAnalysisCharts,
    OutcomeAnalysisCharts,
  },
  props: {
    expanded: {
      type: Boolean,
      required: true,
    },
    highlighted: {
      type: Boolean,
      required: true,
    },
    showAddHelp: {
      type: Boolean,
      required: false,
      default: false,
    },
    showReviewHelp: {
      type: Boolean,
      required: false,
      default: false,
    },
    showFilterHelp: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      variables: [],
      value: [],
      showHelpChip: false,
    };
  },
  computed: {
    ...mapState('cohortManager', {
      inputVariables: state.INPUT_VARIABLES,
      outputVariables: state.OUTPUT_VARIABLES,
      selectedAnalysisMode: state.SELECTED_ANALYSIS_MODE,
    }),
    hasUserAddedOutputVariables() {
      if (this.selectedAnalysisMode == 'Predictor based') {
        return this.outputVariables.length > 0;
      } else {
        return this.inputVariables.length > 0;
      }
    },
  },
  watch: {
    showAddHelp(show) {
      this.showHelpChip = show;
    },
  },
  methods: {
    expandClicked(newval) {
      this.$emit('update:expanded', newval);
    },
    userSelectedOutputVariables() {
      this.$emit('userSelectedOutputVariables', true);
    },
    userChangedOutputVariable() {
      this.$emit('userChangedOutputVariable', true);
    },
    comparePredefinedRanges(ranges) {
      this.$emit('comparePredefinedRanges', ranges);
    },
    savePredefinedRanges(ranges) {
      this.$emit('savePredefinedRanges', ranges);
    },
  },
};
</script>

<style scoped>
.horizontal {
  display: flex;
}
</style>
